import { WorkspaceOwnerBadge } from "@ext/enterprise/components/admin/settings/members/components/WorkspaceOwnerBadge";
import t from "@ext/localization/locale/translate";
import type { ColumnDef } from "@ui-kit/DataTable";
import { GesCommonUserBadge } from "../../../../../../enterpriseCommon/components/roleBadges/GesCommonUserBadge";
import { userBadgesColumnId } from "../../../../../../enterpriseCommon/components/roleBadges/UserBadgesConfig";
import { UserBadgesWrapper } from "../../../../../../enterpriseCommon/components/roleBadges/UserBadgesWrapper";

export interface UserBadgesColumnOptions<T> {
	header?: string;
	isEditor?: (row: T) => boolean;
	isWorkspaceOwner?: (row: T) => boolean;
	isGuest?: (row: T) => boolean;
}

export const userBadgesColumn = <T,>({
	header,
	isEditor,
	isWorkspaceOwner,
	isGuest,
}: UserBadgesColumnOptions<T>): ColumnDef<T> => ({
	id: userBadgesColumnId,
	header: header ?? "",
	cell: ({ row }) => {
		const item = row.original;

		return (
			<UserBadgesWrapper>
				{
					<UserBadges
						isEditor={isEditor?.(item)}
						isGuest={isGuest?.(item)}
						isWorkspaceOwner={isWorkspaceOwner?.(item)}
					/>
				}
			</UserBadgesWrapper>
		);
	},
});

interface MemberBadgesProps {
	isEditor?: boolean;
	isGuest?: boolean;
	isWorkspaceOwner?: boolean;
}

const UserBadges = ({ isEditor, isGuest, isWorkspaceOwner }: MemberBadgesProps) => (
	<>
		{isGuest && <GesCommonUserBadge label={t("enterprise.admin.guests.guest")} />}
		{isEditor && <GesCommonUserBadge label={t("enterprise.admin.users.editor")} />}
		{isWorkspaceOwner && <WorkspaceOwnerBadge />}
	</>
);
